import styled from 'styled-components';

export const Container = styled.div`
  margin: 0;
  width: 100%;
  max-width: 600px;
  background-color: #FFF;
  border: 1px solid var(--light-blue);
  border-radius: 0.25rem;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  .button-left {
    position: absolute;
    top: 50%;
    left: 1%;
  }

  .button-right {
    position: absolute;
    top: 50%;
    right: 1%;
  }

  .button-left, .button-right {
    background: none;
    border: 0;
  }

  header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    strong {
      color: var(--dark-blue);
    }

    .period-container {
      border: 1px solid var(--light-blue);
      border-radius: 4px;
      padding: .1rem;

      .active {
        color: var(--light-blue);
        background-color: #FFF;
      }

      button {
        border: 0;
        background: rgb(242,242,242);
        padding: .4rem .6rem;
        
        &:hover {
          background: #FFF;
        }
      }
    }
  }

  .line-chart {
    padding: 0 1rem;
    margin-left: 1rem;
    width: 100%;
    height: auto;
  }
  @media (max-width: 520px) {
    width: 104%;
    margin-left: -2%;
    z-index: 0;
    border: 0;
    border-radius: 0;
  }
`;
